/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from "react";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Divider } from "@mui/material";
import PropTypes from "prop-types";
import Label from "components/Label";

function CurrentFilter({ filters, clearDataFun }) {
  console.log(filters.length);
  return (
    <div className="b-container-filter">
      <div className="b-container-filter__mainSection">
        {filters.length > 0 && (
          <Label
            label="Current Filters"
            className="b-container-filter__label"
          />
        )}
        <div className="b-container-filter__chieldContainer">
          <div className="b-container-filter__chield">
            {filters.length > 0 &&
              // filters.map((items) => (
              //   <div className="b-container-filter__btnContainer">
              filters.map((items, index) => (
                <div
                  key={items.item?.id || index}
                  className="b-container-filter__btnContainer"
                >
                  <div
                    className="b-container-filter__chieldBtn"
                    onClick={() => clearDataFun(items)}
                  >
                    {items.item.title}

                    <CloseRoundedIcon />
                  </div>
                </div>
              ))}
          </div>

          {filters.length > 0 && (
            <div className="d">
              <div
                className="b-container-filter__clearAllBtn"
                onClick={() => clearDataFun()}
              >
                <span className="b-container-filter__clearAllBtn-text">
                  Clear All
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
      {filters.length > 0 && (
        <div className="incomingReport-hr b-container-filter__divider">
          <Divider className="hr-color" />
        </div>
      )}
    </div>
  );
}

// CurrentFilter.propTypes = {
//   filters: PropTypes.oneOfType([PropTypes.object]).isRequired,
//   clearDataFun: PropTypes.func.isRequired,
// };
CurrentFilter.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      item: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        title: PropTypes.string,
      }).isRequired,
    })
  ).isRequired,
  clearDataFun: PropTypes.func.isRequired,
};

export default CurrentFilter;
